import TopComponent from "./Referpage.jsx/TopComponent";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import number1 from "../../assets/images/Program-info/1.png";
import number2 from "../../assets/images/Program-info/2.png";
import number3 from "../../assets/images/Program-info/3.png";
import number4 from "../../assets/images/Program-info/4.png";
import number5 from "../../assets/images/Program-info/5.png";
import number6 from "../../assets/images/Program-info/6.jpg";
import number7 from "../../assets/images/Program-info/7.png";
import number8 from "../../assets/images/Program-info/8.png";
import number9 from "../../assets/images/Program-info/9.jpg";
import number10 from "../../assets/images/Program-info/10.jpg";
import number11 from "../../assets/images/Program-info/11.jpg";
import number12 from "../../assets/images/Program-info/12.jpg";
import number13 from "../../assets/images/Program-info/13.png";

const p1 = () => {
  return (
    <div className="text-sm">
      Rules for Plurals <br /> <br />
      Singular means one. <br /> <br />
      Plural means more than one.  <br /> <br />
      1. Most nouns are made plural by adding s: <br /> <br />
       More than one boy  = boys <br /> <br />
      More than one girl = girls <br /> <br />
      More than one hat = hats <br /> <br /> 1.  If the word ends in x or s, sh
      or ch, we add es: <br /> <br />
       More than one box = boxes <br /> <br /> More than one bus = buses More
      than one bush = bushes <br /> <br /> More than one coach = coaches <br />{" "}
      <br /> Others: trenches, brushes, dresses, etc <br /> <br />  1. If a noun
      ending in y is preceded by a consonant, change the y to i and add es:
      e.g., sky- skies, story – stories, city – cities, family – families.{" "}
      <br /> <br />   1. For words ending in vowel + y add s: e.g., valley –
      valleys, key – keys, etc  <br /> <br /> Exceptions   <br /> <br /> 1. Some
      words change to make a plural: <br /> <br />  More than one mouse = mice{" "}
      <br /> <br /> More than one man = men <br /> <br /> More than one woman =
      women <br /> <br /> More than one child = children
      <br /> <br /> More than one tooth = teeth. <br /> <br />  1.Some nouns
      that end in f, ff or fe are made plural by changing the f to v and adding
      es: <br /> <br /> e.g., leaf – leaves, knife – knives, shelf – shelves,
      half – halves, life – lives.
      <br /> <br />   1. If a noun ending in o is preceded by a consonant, an es
      is often added: e.g., dingo – dingoes, cargoes, potatoes, tomatoes <br />{" "}
      <br /> 1.  Some nouns have the same form for singular and plural: e.g.,
      sheep, scissors, ice, offspring, gold,    
    </div>
  );
};

const p2 = () => {
  return (
    <div>
      Syllables are the parts of a word that are spoken as a single unit, which
      together make up a word. <br /> <br />
      A good understanding of syllables is an important skill that students can
      use to learn the spelling of long, complicated words. Breaking a word into
      syllables helps a student memorise the spelling of a word. <br /> <br />
      Don’t get hung up about exactly the exact placement of a syllable break.
      The number of syllables is more important than identifying the exact
      syllable breaks. Most dictionaries will show the syllables in the word.
      Different conventions are used. The Kitehawk Program follows the
      International Phonics notation. Here doubled consonants are not separated
      as they make only one sound in speech e’g’, ca/ttle. The Merriam Webster
      dictionary usually splits doubled consonants e.g., cat / tle. Either form
      of notation is suitable for breaking a word into syllables. <br /> <br />
      There are many techniques used to learn how to break syllables into words.
      Some teachers call syllables ‘jaw droppers’. If you cup your hand under
      your jaw, the jaw will drop each time a syllable is spoken. The jaw drops
      because there is a vowel sound in each syllable. When breaking words into
      syllables, the students can clap each of syllables as they say the word
      Another method is to sing the word, because when we sing a word we
      naturally break words into syllables. Syllables occur in all languages and
      can be taught in local languages. For example, the word ‘kangaroo’ from
      Western Desert Aboriginal language is ‘marlu’, which has two syllables ‘
      mar / lu ‘. <br /> <br />
      Rules for Syllables: <br /> <br />
      1. Every syllable has a vowel or vowel sound. <br /> <br />
      The y in funny makes the long /ee/ vowel sound. The y in sky makes the
      long /igh/ vowel sound. <br /> <br />
      Breaking a word into syllables is not an exact science. There can be more
      than one answer. (e.g, evolution: ev-ol-u’-shun, <br /> e-vo-lu’-shun).{" "}
      <br />
      The important point is the number of syllables is the same. <br />
      There are different ways of pronouncing words and writing syllables. All
      have merit and all are useful. <br />
      (e.g., billycan: bi / lly / can, bil / ly / can, bill / y / can) <br />
      Note each syllable has a vowel sound. Either way of breaking the word into
      syllables is OK for teaching purposes. I prefer the former example because
      it fits the next rule about breaking double consonants. <br /> <br />
      A general rule break syllables before or after doubled consonants (e.g.,
      ca / ttle, sci/ ssors, ye / llow, etc). <br /> <br />
      Compound words, prefixes and suffixes are usually separated as syllables
      (un / tie, care / ful, pass / word) <br />
      Some larger dictionaries break words into syllables. Some show the
      separation of syllables with dots (e.g., vo٠cab٠u٠lar٠y which has five
      syllables) others use a ‘swinging apostrophe’.. <br /> <br />
      A single consonant between two vowels goes with the second vowel if the
      first vowel is long. (e.g., o / val, i / de / a, ti / ger, to / tal, etc.)
      See Unit 3-13. <br /> <br />
      Words with two consonants between two vowels are divided into syllables
      between the consonants. See Unit 3-15. <br />
      Example: p e r٠ s o n c o m ٠ p a s s p r o b ٠ l e m <br />
      v c ٠ c v v c ٠ c v v c ٠ c v <br /> <br />
      Pronunciation <br /> <br />
      The stress mark shown in words in the dictionary should not be confused
      with syllables. The stress marks in a dictionary show where the emphasis
      is placed in a word. The main stress or accent is shown by a mark usually
      before the stressed vowel. <br />
      For example in the word vo ‘cab u lar y – the dictionary shows the stress
      in pronunciation is on “ ‘cab “ – in the second syllable.
    </div>
  );
};

const p3 = () => {
  return (
    <div>
      General Rules for Suffixes or Word Endings <br /> <br />A suffix is added
      to the end of a root, which is either a whole word or part of a word. The
      suffix changes its meaning and its part of speech. <br /> <br />
      Rules: The following rules are general and there are many exceptions to
      them. Some have been given but do not need to be taught in the lower
      levels. <br /> <br />
      Adding suffixes that start with a vowel (e.g., ed, ing, able, ous, er,){" "}
      <br /> <br />
      If there is a vowel and then a consonant at the end of a word, double the
      consonant. <br /> <br />
      win + ing = winning, hop + ing = hopping, hop + er = hopper, hop + ed =
      hopped, batted, shovelled, labelled, etc <br />
      Where words end in ‘y’, change the ‘y to ‘i’ and add the suffix.
      <br />
      happy + est = happiest, carry + ed = carried, sunny + er = sunnier, reply
      + ed = replied, lazy + est + laziest, etc <br /> <br />
      Exceptions: reply +ing = ing <br /> <br />
      When a word ends in a silent e, drop the e if the suffix begins with a
      vowel.
      <br />
      ride – riding; make – making, use – using, nerve – nervous, like + ed =
      liked, coming, etc <br />
      Adding suffixes that start with a consonant
      <br />
      Where a suffix starts with a consonant, just add it. <br />
      ness, less, ment, ful, ly, etc
      <br />
      <br />
      sad + ness = sadness sickness, sick + ness = sickness, goodness, etc{" "}
      <br />
      sleep + less = sleepless, helpless, etc
      <br />
      govern + ment = government, excite + ment = excitement, judgement, etc
      <br />
      sad + ly = sadly, wise + ly = wisely, etc.
      <br />
      <br />
      In most cases the silent ‘e’ is retained.
      <br />
      Exceptions: awful, argument, wisdom, wholly, happiness, bodily, etc.
      <br />
      <br />
      Where the suffix ‘full’ is added, just drop the final ‘l’.
      <br />
      help + full = helpful, hope + full = hopeful, harmful, playful, etc.
      <br />
    </div>
  );
};

const p4 = () => {
  return (
    <div>
      Compound words are formed by joining two or more words. <br /> <br />
      The Kitehawk Learning Spelling Program uses compound words extensively, to
      teach spelling using a variety of exercises. Compound words can help build
      a student’s confidence in spelling long words and improve their
      vocabulary. <br /> <br />
      In most of the exercises, the compound words have one word that is a list
      word. Knowing how to spell part of the compound word helps a student learn
      the longer and more complex words, and builds their confidence. <br />
      <br />
      There is often a question as to whether to use a hyphen or just join two
      words. <br />
      <br />
      Dictionaries don’t always agree about when a hyphen should be used or when
      a compound word should be formed. With increasing use, two words can
      become joined. <br />
      <br />
      Many words that were previously hyphenated are now compound words.
      <br />
      <br />
      Recently evolved examples of compound words are: download, taxpayer,
      callback, winegrowing, lifesaving, bestseller, childbearing,
      spellcheckers, feedback, talkback (radio), messagebank, photocopy, and
      many more.
    </div>
  );
};

const p5 = () => {
  return (
    <div>
      Long vowel sounds are the most difficult part of the English language to
      master. <br /> <br />
      Rhyming exercises explore the many different ways the same long vowel
      sound can be spelled. <br />
      <br />
      For example, in reading, writing and spelling, there are about 15
      different letter combinations that make the long /igh/ sound in high.{" "}
      <br />
      <br />
      Rhyming word activities are an effective way of studying these difficult
      and confusing long vowel sounds. <br />
      <br />
      Rhyming words that end with a vowel sound are open rhymes. The focus is
      always on the last syllable (e.g., blue – flew).
      <br />
      <br />
      Those rhymes that end with a vowel sound then a consonant are closed
      rhymes. Again, the focus is on the last syllable (e.g., sweet – wheat).
      <br />
      <br />
      Rhyming word activities develop thinking and problem-solving skills. They
      focus on the last vowel sound or vowel consonant sound in the word, and
      the different letter combinations that make the same long vowel sound.
    </div>
  );
};

const p6 = () => {
  return (
    <div>
      The Guide Words Activities develop the important dictionary skill of being
      able to find words quickly. The aim is to help students quickly find new
      words or different meanings of words. The habit of using a dictionary
      (preferably a printed version) is vital to the ability to learn, and to
      learn independently.
      <br /> <br /> The Kitehawk Program uses guide words to expose students to
      uncommon words and also to develop their vocabulary. Some hopefully
      unfamiliar words are purposely included in Programs 3, 4 & 5, that will
      require students to refer to a dictionary. <br /> <br />
      The Oxford Australian School Dictionary seems well suited for Programs 3,
      4 & 5 because it contains Latin and Greek roots. A few higher-level
      dictionaries should be available in each classroom, so that students can
      find less common words for meaning, stress, syllables and pronunciation.
      Many words students encounter are not found in basic school dictionaries.
      In addition to the Activities in the Online Program, and the exercises in
      the workbooks, other dictionary skills need to be taught for independent
      learning. Activities – Estimating the position of a word in a dictionary
      <br />
      Teach students to estimate where a word will be found in a dictionary.
      <br />
      For example, if you open the dictionary in the middle you will find l, m,
      n and o. If you open the dictionary at the first quarter you will find d
      and e. If you open the dictionary three quarters of the way through the
      dictionary, you will find r and s. <br /> <br />
      A good exercise to develop this word finding skill is to see if students
      can find a given word (write it on the board), by not opening the
      dictionary more than four times.
      <br />
      Other exercises seeking information can develop dictionary skills:
      <br />
      They are:
      <br />
      <ul className="list-disc mt-5">
        <li>Using the index in an atlas to find place names.</li>
        <li>
          Using the index in a recipe book to find their favourite recipes.
          There may be some lying around unused at home.
        </li>
        <li>Using the index in a gardening book.</li>
      </ul>
      <br />
      <br />
      Study the information on a page in the dictionary
      <br />
      Photocopy a page from a good student dictionary and give a copy to each
      child and explain the features on the page.
      <br />
      <ul className="list-disc mt-5">
        <li>
          The two words in bold at the top of the page are guide words. They
          tell you the first and last words on the page. The guide words should
          be used first, to ensure the student is looking on the correct page
          for the word.
          <br />
          <br />
        </li>
      </ul>
      The entry for a word should contain:
      <br />
      <ul className="list-disc mt-5">
        <li>
          The root or base word, sometimes called the headword included with
          this listing.{" "}
        </li>
        <li>
          The part of speech. Whether the word is a noun, verb, adjective,
          etc.{" "}
        </li>
        <li>How the word is pronounced, showing which vowels are stressed </li>
      </ul>
      (e.g., ‘ha / mmer – the first syllable ‘ha is stressed).
      <br />
      <ul className="list-disc mt-5">
        <li>
          Sometimes the syllables within a word are shown, separated by a dot
          (e.g., ca٠ttle).
        </li>
        <li>The Greek or Latin origin of the word, and</li>
        <li>
          Most importantly, the various meanings and spellings of the word.
        </li>
      </ul>
      <br />
      <br />
      Arrange the books on a shelf in alphabetical order by title or by author.
      <br />
      In this activity each student can rearrange the order of stacking.
      <br />
    </div>
  );
};

const p8 = () => {
  return (
    <div>
      The Kitehawk Program has a basic set of Activities in all 5 Programs.
      These activities increase in complexity as students progress through the
      program.
      <br />
      The Activities all have a teaching and learning purpose, and relate to the
      List Words where possible. The repetition, or practise, involved in
      writing and better understanding these words, helps to remember the
      spelling. The skills developed by the Activities are designed to help
      students learn independently. <br />
      <br />
      Students should be encouraged to use a dictionary when completing all
      Programs, particularly in Programs 3, 4 and 5. The development of
      dictionary skills, and the habit of using a dictionary where a word is not
      known or its meaning uncertain, help improve literacy. <br />
      <br />
      The Oxford Australian School Dictionary has most of the answers required.
      The Oxford Dictionary has Latin & Greek roots, which are not in the
      Macquarie Dictionary (Young Students). <br />
      <br />
      Grammar Activities
      <br />
      The Grammar Activities explore basic grammar – parts of speech, phrases,
      punctuation and editing. These skills are required to better understand
      the structure of English and to improve writing. <br /> <br />
      Missing Word Activities
      <br />
      The Missing Word Activities reinforce the learning of list words used in
      context in a sentence.
      <br />
      <br />
      Small Words Activities
      <br />
      Identifying small words within list words reinforces the learning of those
      list words. Using this technique on longer words can help students learn
      their spelling.
      <br />
      <br />
      Blend Activities
      <br />
      The Blend Activities systematically look at the many blends or consonant
      cluster found in the English language. The Activities <br />
      reinforce the learning of skills needed to learn to spell words
      independently. When reviewing the answers to these Activities, <br />
      encourage the students to suggest other words that start or end with these
      blends and write them on the board.
      <br />
      <br />
      Rhyming Word Activities
      <br />
      These Activities require the student to find list words that rhyme with
      nominated words. These Activities reinforce the spelling of list words
      but, more importantly they explore the many ways of writing long vowel
      sounds.
      <br />
      The rhymes can be open, where they end in the same vowel sound, or closed
      where they end with the same vowel sound and same end consonant – both in
      the same syllable. (e.g., open: blue – flew closed: sweet – wheat). <br />
      Rhyming exercises explore the many different ways the same long vowel can
      be spelled. Using the correct long vowel sound spelling in English is a
      difficult area to master. <br />
      Rhyming Words Activities develop thinking and problem solving skills, by
      focusing on the last vowel sound, or vowel consonant sound. And thinking
      about the different letter combinations that make the same long vowel
      sounds.
      <br />
      <br />
      Changing Words Activities
      <br />
      The Changing Words Activities not only develop spelling skills, but also
      develop problem solving skills. They can also teach students to carefully
      read questions. A question can ask to change a vowel, or a consonant or a
      letter, in order to make a List Word. Failure to read the question often
      lead to getting the wrong answer. Students also learn short cuts. If asked
      to change a vowel, then they learn the consonant stays the same and can
      search for words with that consonant.
      <br />
      <br />
      Prefix & Suffix Activities
      <br />
      The Prefix and Suffix Activities explore various prefixes and suffixes.
      They also reinforces the learning of list words and their related words.
      <br />
      <br />
      Compound Word Activities
      <br />
      The Compound Word Activities use words linked to list words. This repeats
      the spelling of list words in word building and vocabulary Activities.
      Students should be encouraged to use a dictionary, when completing these
      Activities in Programs 3, 4 and 5. The development of dictionary skills
      and the habit of using a dictionary where a word is not known or its
      meaning uncertain, are needed to improve literacy.
      <br />
      <br />
      Word Building Activities
      <br />
      The Word Building Activities seek the base or root list word, from which
      the given word is built. <br />
      <br />
      Dictionary Skills Activities
      <br />
      The Dictionary Skills Activities reinforce the learning of list words and
      help to develop dictionary skills needed to learn to spell and research
      words – skills also needed to learn independently.
      <br />
      <br />
      Synonym and Antonym Activities
      <br />
      The Synonym and Antonym Activities are potent vocabulary building
      activities, as well as providing an opportunity to practice the spelling
      of list words.
      <br />
      <br />
      Homophone Activities
      <br />
      The Homophone Activities are explored through selected list words to learn
      the various spellings and meanings of homophones. <br />
      Homophones are always a difficult part of the English language to master.
      In the Activities the student must study the context of the sentence to
      make the correct homophone choices.
      <br />
      <br />
      Word Chain Activities
      <br />
      Word Chain Activities develop problem-solving skills. These Activities
      involve thinking about the correct spelling of many common words. There
      are techniques that can be learned to helps solve the chain. The student
      learns how to imagine new words by changing one of the four letters of the
      next word.
      <br />
      <br />
      For example: <br />
      b o a t<br />
      c o a t<br />
      c o l t<br />
      c o l d
      <br />
      Working backwards from the last word often help solve the chain. This is
      an effective way of developing the brain, to picture words that are
      possible solutions
    </div>
  );
};

const p7 = () => {
  return (
    <div>
      Dictation and phonics are two of the most potent literacy teaching tools.
      Dictation can improve the four language skills: listening, speaking,
      reading and writing. <br /> <br />
      Many teachers know the power of dictation in teaching literacy, even
      though dictation has fallen out of favour. It is considered, by some
      teachers, as a ‘past practice’.
      <br />
      <br />
      Learning to write what you hear can help the development of literacy.
      <br />
      <br />
      The dictation exercises in the Kitehawk Program, review the student’s
      knowledge of the spelling of current and recent list words, as well as the
      ‘core’ or ‘Must Know’ words, that make up 75% of the words commonly used
      in writing at each Level. <br />
      <br />
      Dictation exercises can test a student’s knowledge of punctuation,
      including the capitalisation of words, question marks, direct speech
      punctuation and the use of apostrophes. Students can learn grammar through
      the relationships of words and phrases they hear and write.
      <br />
      <br />
      Dictation can also improve the student’s understanding of the meaning of
      words. Importantly, dictation can test knowledge of homophones where
      context is needed to determine the correct spelling e.g., won, one, there,
      their, etc.
      <br />
      <br />
      Dictation is important for teaching students listening skills. If each
      sentence is repeated a set number of times (usually twice), the students
      soon learn that if they don’t listen, they get a poor score.
      <br />
      <br />
      Dictation is important for learning many critical small words that are
      often missing from many spelling programs, because the writers assume
      students can spell words such as: was, you, the, who, know, their, and so
      on.
      <br />
      <br />
      Dictation exercises are important at the start of a lesson. Dictation can
      help inexperienced teachers gain the attention and control of the class by
      focussing students’ attention on the exercise. Dictation involves the
      whole class and the teacher can move about the class, viewing each
      student’s work while dictating sentences or passages.
      <br />
      <br />
      The students, as well as the teacher, can get valuable feedback if the
      exercise is corrected immediately after the dictation. The students can
      swap papers and correct the dictation as the teacher reads or writes the
      passage. The teacher will have the final say on corrections.
      <br />
      <br />
      To improve speaking skills, get students to read dictation exercises.
      Dictation can also help students develop sub-conscious thinking in
      English.
      <br />
      <br />
      <h3 className="font-bold"> Procedure for Dictation. </h3>
      <br />
      <br />
      <ol className="list-decimal ">
        <li>
          The teacher reads the dictation as students listen with pen or pencils
          down.
          <br />
          <br />
        </li>
        <li>
          As the teacher rereads each passage, phrase by phrase, the students
          write it. The teacher repeats each phrase.
          <br />
          <br />
        </li>
        <li>
          On completion, the teacher repeats each sentence slowly so students
          can check that every word has been written and that punctuation is
          correct.
        </li>
      </ol>
    </div>
  );
};

const p9 = () => {
  return (
    <div>
      Program 4 is designed to be one year’s work in a typical classroom setting
      where one Unit is completed each week. The standard is for Grade 6 level
      or the average student aged about 11 years. The program is written in
      plain English.
      <br /> <br />
      Program 4 has the same style of exercise as Program 2 and Program 3 which
      gives students confidence when attempting Activities. The Activities are
      again marginally more difficult than Program 2.
      <br />
      <br />
      The knowledge and skills taught are: <br />
      <br />
      <ul className="list-disc ml-4">
        <li>
          The 250 ‘Must Know´ listed at the start of Program 4, include the 125
          Program 3 ‘Must Know’ words. They form about 75% of writing at this
          level and learning these words is essential for success in writing and
          reading.
          <br />
          <br />
        </li>
        <li>
          Many of the Activities in Program 4 are designed to be completed using
          a student dictionary.
          <br />
          <br />
        </li>
        <li>
          Program 4 continues the focus on developing skills by providing more
          complex Activities especially phonemes, spelling patterns / skills,
          syllables, prefixes and suffixes, etc.
          <br />
          <br />
        </li>
        <li>
          There is a stronger focus on Latin and Greek roots, base words and
          grammar.
          <br />
          <br />
        </li>
        <li>
          Program 4 has a much stronger emphasis on vocabulary building and
          development using vocabulary building exercises, synonyms, antonyms
          and guide words Activities.
          <br />
          <br />
        </li>
        <li>
          A higher level of difficulty in Program 4 further developed previously
          learned literacy skills such as editing writing, dictionary skills,
          blends, homophones, synonyms, antonyms, doubled consonants,
          contractions, prefixes and suffixes, plurals, Latin and Greek roots of
          English, confused words, base words, guide words, abbreviations and
          punctuation nouns – proper nouns, collective nouns, pronouns, verbs
          and verbs tenses, adverbs, adjectives, prepositions, conjunctions and
          more basic grammar including compound verbs, adverbial phrases,
          adjectival phrases, plurals and verbs, direct and indirect speech and
          statement and questions.
          <br />
          <br />
        </li>
        <li>
          New skills and knowledge developed include abstract nouns, stress and
          pronunciation, exceptions to spelling rules, use of punctuation – the
          comma and the apostrophe, transition and sequence words. More complex
          confused words, metaphors, acronyms and combined words are other newly
          introduced Activities.
          <br />
          <br />
        </li>
        <li>
          Word Building lists provide word relationships, extension, and
          vocabulary building.
          <br />
          <br />
        </li>
      </ul>
      All Activities require thinking – there is no ‘busy’ work in the program.
      The answers to about 80% of the Activities of each Unit are the List Words
      of that unit which encourages students to persevere.
      <br />
      <br />
      The teaching of concepts is still required.
      <br />
      <br />
      The online Activities are designed to challenge and engage students in a
      stimulating way.
    </div>
  );
};

const p10 = () => {
  return (
    <div>
      Program 3 is designed to be one year’s work in a typical classroom setting
      where one Unit is completed each week. The standard is for Grade 5 level
      or the average student aged about 10 years. The program is written in
      plain English. <br /> <br />
      Program 3 has the same style of exercise as Program 1 and Program 2 which
      gives students confidence when attempting Activities. The Activities are
      again marginally more difficult than Program 2. <br />
      <br />
      The content, and the knowledge and skills taught are:
      <br />
      <br />
      <ul className="list-disc">
        <li>
          The 125 ‘Must Know´ listed at the start of Program 3, include the 50
          Program 2 ‘Must Know’ words. They form about 75% of writing at this
          level and learning these words is essential for success in writing and
          reading.
          <br />
          <br />
        </li>
        <li>
          Many of the Activities in Program 3 are designed to be completed using
          a student dictionary.
          <br />
          <br />
        </li>
        <li>
          Program 3 covers more complex phonemes and digraph, contractions,
          abbreviations and more complex long vowel sounds.
          <br />
          <br />
        </li>
        <li>
          There is a stronger focus on syllables, base words and root words and
          more focus on grammar.
          <br />
          <br />
        </li>
        <li>
          Program 3 has a much stronger emphasis on vocabulary building or
          development in the Activities.
          <br />
          <br />
        </li>
        <li>
          A higher level of difficulty in Program 3 further developed previously
          learned literacy skills such as editing writing, dictionary skills,
          blends, homophones, synonyms, antonyms, doubled consonants,
          contractions, prefixes and suffixes, plurals, nouns – proper nouns,
          collective nouns, pronouns, verbs and verbs tenses, adverbs,
          adjectives and conjunctions.
          <br />
          <br />
        </li>
        <li>
          New skills and knowledge developed include Latin and Greek roots,
          confused words, base words, guide words, abbreviations and
          punctuation, more basic grammar including prepositions, compound
          verbs, adverbial phrases, adjectival phrases, plurals and verbs,
          direct and indirect speech and statement and questions.
          <br />
          <br />
        </li>
        <li>
          Word Building lists provide word relationships, extension, and
          vocabulary building.
          <br />
          <br />
        </li>
      </ul>
      All Activities require thinking – there is no ‘busy’ work in the program.
      The answers to about 80% of the Activities of each Unit are the List Words
      of that unit which encourages students to persevere.
      <br />
      <br />
      The teaching of concepts is required.
      <br />
      <br />
      The online Activities are designed to challenge and engage students.
    </div>
  );
};


const p11 = () => {
  return (
    <div>
      Program 1 is designed to be one year’s work in a typical classroom setting
      where one Unit is completed each week. The standard is for Grade 3 level
      or the average student aged about 8 years. The program is written in
      plain English.
      <br />
      <br />

      Students should know the alphabet and have a rudimentary knowledge of
      phonics before they start Program 1.
      <br />
      <br />

      The content, and the knowledge and skills taught at the start of Program 1
      are ‘full-on’.
      <br />
      <br />

      The content, and the knowledge and skills taught are:
      <br />
      <br />

      <ul className="list-disc">
        <li>
          Unit 1 has the longest word list consisting of the 15 most frequently
          used ‘Must Know’ words (some difficult sight words) at this level.
          They form about 75% of writing at this level and learning these words
          is essential to success in writing and reading.
          <br />
          <br />
        </li>

        <li>
          The print version of Program 1 has a dictionary of List Words
          included, so access to a simple student dictionary will help develop
          dictionary skills and accelerate learning.
          <br />
          <br />
        </li>

        <li>
          The important understanding of vowels and consonants are learned.
          <br />
          <br />
        </li>

        <li>
          Learning to clearly read instructions is a skill focussed on early.
          Students are taught to read the whole question and not assume the
          question.
          <br />
          <br />
        </li>

        <li>
          Short vowel sounds and important non-phonetic words are covered. Long
          vowel sounds and digraphs are introduced later in the program.
          <br />
          <br />
        </li>

        <li>
          The concept of syllables is introduced.
          <br />
          <br />
        </li>

        <li>
          Dictionary skills, blends, homophones, synonyms, antonyms, doubled
          consonants, contractions, prefixes and suffixes, plurals, nouns and
          verbs are taught.
          <br />
          <br />
        </li>

        <li>
          Word Building lists provide word relationships, extension, and
          vocabulary building.
          <br />
          <br />
        </li>
      </ul>

      All Activities require thinking – there is no ‘busy’ work in the program.
      The answers to about 80% of the Activities of each Unit are the List Words
      of that unit which encourages students to persevere.
      <br />
      <br />

      The teaching of basic concepts is required.
      <br />
      <br />

      The online Activities are designed to challenge and engage students in a
      stimulating way.
    </div>
  );
};

const p12 = () => {
  return (
    <div>
      Program 2 is designed to be one year’s work in a typical classroom setting
      where one Unit is completed each week. The standard is for Grade 4 level
      or the average student aged about 9 years. The program is written in
      plain English.
      <br />
      <br />

      Program 2 has the same style of exercise as Program 1 which gives students
      confidence when attempting Activities. Similar Activities are marginally
      more difficult than Program 1.
      <br />
      <br />

      The program ensures that students who complete Program 2 will have basic
      functional literacy and have developed independent learning skills to
      allow them to complete higher levels of the program with minimal
      assistance.
      <br />
      <br />

      The content, and the knowledge and skills taught are:
      <br />
      <br />

      <ul className="list-disc">
        <li>
          The 50 ‘Must Know’ listed at the start of Program 2 include the 15
          Program 1 ‘Must Know’ words. They form about 75% of writing at this
          level and learning these is essential to success in writing and
          reading.
          <br />
          <br />
        </li>

        <li>
          Most basic phonemes and digraphs are covered, with a focus on more
          complex long vowel sounds.
          <br />
          <br />
        </li>

        <li>
          Syllables receive more attention.
          <br />
          <br />
        </li>

        <li>
          The concept of Parts of Speech is introduced.
          <br />
          <br />
        </li>

        <li>
          At a higher level of difficulty, previously learned skills are further
          developed such as dictionary skills, blends, homophones, synonyms,
          antonyms, doubled consonants, contractions, prefixes and suffixes,
          plurals, nouns, and verbs.
          <br />
          <br />
        </li>

        <li>
          New skills and knowledge introduced include editing writing, proper
          nouns, collective nouns, pronouns, verb tenses, adverbs, adjectives,
          conjunctions and the schwa sound.
          <br />
          <br />
        </li>

        <li>
          Word Building lists provide word relationships, extension, and
          vocabulary building.
          <br />
          <br />
        </li>
      </ul>

      All Activities require thinking – there is no ‘busy’ work in the program.
      The answers to about 80% of the Activities of each Unit are the List Words
      of that unit which encourages students to persevere.
      <br />
      <br />

      The teaching of concepts is required.
      <br />
      <br />

      The online Activities are designed to challenge and engage students in a
      stimulating way.
    </div>
  );
};

const p13 = () => {
  return (
    <div>
      Program 5 is designed to be one year’s work in a typical classroom setting
      where one Unit is completed each week. The standard is for Grade 7 level
      or the average student aged about 12 years or older. The program is
      written in plain English.
      <br />
      <br />

      Program 5 has the same style of exercise as Programs 1, 2, 3 and 4, which
      gives students confidence when attempting Activities. The Activities are
      marginally more difficult than Program 4.
      <br />
      <br />

      The knowledge and skills taught include:
      <br />
      <br />

      <ul className="list-disc">
        <li>
          The 500 ‘Must Know’ listed at the start of Program 5 include the 250
          Program 4 ‘Must Know’ words. They form about 75% of writing at this
          level and learning these words is essential for improving writing and
          reading.
          <br />
          <br />
        </li>

        <li>
          Many of the Activities in Program 5 are designed to be completed using
          a student dictionary, which helps expand vocabulary.
          <br />
          <br />
        </li>

        <li>
          Program 5 focuses on strategies previously learned and revises earlier
          literacy skills. These are further developed through more complex
          Activities such as phonemes, spelling patterns, syllables, prefixes
          and suffixes.
          <br />
          <br />
        </li>

        <li>
          There is a strong focus on confused words, vocabulary building,
          dictionary skills, and Latin and Greek roots.
          <br />
          <br />
        </li>

        <li>
          A higher level of difficulty further develops previously learned
          literacy skills such as editing writing, dictionary skills, blends,
          homophones, syllables, synonyms, antonyms, rhyming words, silent
          letters, doubled consonants, compound words, prefixes and suffixes,
          plurals, Latin and Greek roots, base words, theme words, parts of
          speech, pronouns, verb tenses, adverbs, and adjectives.
          <br />
          <br />
        </li>

        <li>
          Additional Activities cover stress, pronunciation, and exceptions to
          spelling rules.
          <br />
          <br />
        </li>

        <li>
          At the end of Program 5 there are useful tables of Latin and Greek
          roots and common prefixes and suffixes.
          <br />
          <br />
        </li>

        <li>
          Word Building lists provide word relationships, extension, and
          vocabulary building.
          <br />
          <br />
        </li>
      </ul>

      All Activities require thinking – there is no ‘busy’ work in the program.
      The answers to about 80% of the Activities of each Unit are the List Words
      of that unit, which encourages students to persevere.
      <br />
      <br />

      The teaching of concepts is still required.
      <br />
      <br />

      The online Activities have a wider scope and are designed to challenge and
      engage students in a stimulating way.
    </div>
  );
};




const LinkingPage = () => {
  const AboutContent = [
    {
      id: 1,
      heading: "Plurals of Nouns ",
      subheading: " about-content ",
      backgroundimage: number1,
      child: p1,
    },
    {
      id: 2,
      heading: "Syllables",
      subheading: " about-content ",
      backgroundimage: number2,
      child: p2,
    },
    {
      id: 3,
      heading: "Suffixes",
      subheading: " about-content ",
      backgroundimage: number3,
      child: p3,
    },
    {
      id: 4,
      heading: "Why Study Compound Words?",
      subheading: " about-content ",
      backgroundimage: number4,
      child: p4,
    },
    {
      id: 5,
      heading: "Why Study Rhyming Words?",
      subheading: " about-content ",
      backgroundimage: number5,
      child: p5,
    },
    {
      id: 6,
      heading: "Guide Words – Dictionary Skills and Building Vocabulary",
      subheading: " about-content ",
      backgroundimage: number6,
      child: p6,
    },
    {
      id: 7,
      heading: "Dictation – An Important Literacy Teaching Tool",
      subheading: " about-content ",
      backgroundimage: number7,
      child: p7,
    },
    {
      id: 8,
      heading: "Learning Benefits of Different Types of Activities",
      subheading: " about-content ",
      backgroundimage: number8,
      child: p8,
    },
    {
      id: 9,
      heading: "Overview of Program 4",
      subheading: " about-content ",
      backgroundimage: number9,
      child: p9,
    },
    {
      id: 10,
      heading: "Overview of Program 3",
      subheading: " about-content ",
      backgroundimage: number10,
      child: p10,
    },
     {
      id: 11,
      heading: "Overview of Program 1",
      subheading: " about-content ",
      backgroundimage: number11,
      child: p11,
    },
       {
      id: 12,
      heading: "Overview of Program 2",
      subheading: " about-content ",
      backgroundimage: number12,
      child: p12,
    },
       {
      id: 13,
      heading: "Overview of Program 5",
      subheading: " about-content ",
      backgroundimage: number13,
      child: p13,
    },
  ];

  const { indexing } = useParams();
  const [data, setdata] = useState({}); 

  const collectingData = () => {
    if (!indexing) {
      return;
    }

    const obj = AboutContent.filter((item) => item.id === Number(indexing));
    return setdata(obj[0]);
  };
  useEffect(() => {
    if (indexing) {
      collectingData();
    }
  }, [indexing]);

  return <>{data.id ? <TopComponent data={data} /> : " "}</>;
};

export default LinkingPage;
